import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Label,
  Row,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Field, Formik, Form } from "formik";
import {
  CONVERT_BOOL,
  POSITIVE,
  REQUIRED,
  SelectionField,
  TextField,
} from "../../Components/constants/field";
import {
  findByIdVehicle,
  getAllActiveVehicleType,
  getAllCities,
  insertVehicle,
  updateVehicle,
} from "../../slices/thunks";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../Components/Common/Loader";
import * as Yup from "yup";

const CreateVehicle = () => {
  const history = useNavigate();
  const { ID } = useParams();
  const dispatch = useDispatch();
  const { cities, loading: CityLoading } = useSelector((state) => state.City);
  const {
    vehicleDetail: { form },
  } = useSelector((state) => state.Vehicle);
  const { vehicleTypes, loading: VehicleLoading } = useSelector(
    (state) => state.Vehicle
  );

  useEffect(() => {
    dispatch(getAllCities());
    dispatch(getAllActiveVehicleType());
  }, []);

  useEffect(() => {
    if (ID) {
      let params = {
        ID: ID,
      };
      dispatch(findByIdVehicle(params));
    }

  }, [ID]);

  const handleSubmit = (values) => {
    let obj = {
      ...values,
    };

    obj.IsActive = CONVERT_BOOL.test(obj?.IsActive);
    obj.VehicleTypeID = obj.VehicleTypeID ? +obj.VehicleTypeID : null;
    obj.CityID = obj.CityID ? +obj.CityID : null;

    if (obj?.ID) {
      dispatch(updateVehicle(obj)).then((res) => {
        if (res.payload && res.payload.Status === 200) {
          history(`/vehicle`);
        }
      });
    } else {
      delete obj?.ID;
      dispatch(insertVehicle(obj)).then((res) => {
        if (res.payload && res.payload.Status === 200) {
          history(`/vehicle`);
        }
      });
    }
  };

  if (CityLoading || VehicleLoading) {
    return <Loader />;
  }
  return (
    <div className="page-content">
      <Container fluid>
        <ToastContainer />
        <BreadCrumb title="Vehicle" pageTitle="Vehicle" />
        <Row>
          <Col xl={12}>
            <Card color="dark" outline>
              <CardHeader className="bg-light">
                <Row className="align-items-center">
                  <Col md="11">
                    <h4 className="card-title mb-0">
                      {ID ? "Update Vehicle" : " Create Vehicle"}
                    </h4>
                  </Col>
                  <Col md="1">
                    <Link to="/vehicle">
                      <Button color="primary" block>
                        Back
                      </Button>
                    </Link>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col lg={12}>
                    <Formik
                      enableReinitialize={true}
                      initialValues={form}
                      validationSchema={Yup.object({
                        CityID: Yup.number()
                          .transform((value) =>
                            Number.isNaN(value) ? null : value
                          )
                          .nullable()
                          .required(REQUIRED),
                        VehicleTypeID: Yup.number()
                          .transform((value) =>
                            Number.isNaN(value) ? null : value
                          )
                          .nullable()
                          .required(REQUIRED),
                        NoOfSeats: Yup.number()
                          .transform((value) =>
                            Number.isNaN(value) ? null : value
                          )
                          .nullable(true)
                          .positive(POSITIVE)
                          .min(0, "Min 0 allowed")
                          .max(99, "Max 2 Digit Number Allowed")
                          .required(REQUIRED),
                        RatePerKm: Yup.number()
                          .transform((value) =>
                            Number.isNaN(value) ? null : value
                          )
                          .nullable(true)
                          .positive(POSITIVE)
                          .min(0, "Min 0 allowed")
                          .max(999999, "Max 6 Digit Number Allowed")
                          .required(REQUIRED),
                        KmPerDay: Yup.number()
                          .transform((value) =>
                            Number.isNaN(value) ? null : value
                          )
                          .nullable(true)
                          .positive(POSITIVE)
                          .min(0, "Min 0 allowed")
                          .max(9999, "Max 4 Digit Number Allowed")
                          .required(REQUIRED),
                        DriverAllowancePerDay: Yup.number()
                          .transform((value) =>
                            Number.isNaN(value) ? null : value
                          )
                          .nullable(true)
                          .positive(POSITIVE)
                          .min(0, "Min 0 allowed")
                          .max(9999, "Max 4 Digit Number Allowed")
                          .required(REQUIRED),
                        PickUpWithinCity: Yup.number()
                          .transform((value) =>
                            Number.isNaN(value) ? null : value
                          )
                          .nullable(true)
                          .positive(POSITIVE),
                        DropWithinCity: Yup.number()
                          .transform((value) =>
                            Number.isNaN(value) ? null : value
                          )
                          .nullable(true)
                          .positive(POSITIVE),
                        EightHrEightyKmWithinCity: Yup.number()
                          .transform((value) =>
                            Number.isNaN(value) ? null : value
                          )
                          .nullable(true)
                          .positive(POSITIVE),
                      })}
                      onSubmit={handleSubmit}
                    >
                      {() => {
                        return (
                          <Form noValidate autoComplete="off">
                            <div>
                              <Row>
                                <Col lg={6}>
                                  <div className="mb-3">
                                    <Label
                                      className="form-label"
                                      htmlFor="CityID"
                                    >
                                      City:
                                    </Label>
                                    <Field
                                      name="CityID"
                                      id="CityID"
                                      options={
                                        Array.isArray(cities) &&
                                        cities.map((city) => {
                                          return {
                                            value: Number(city.ID),
                                            label: city.CityName,
                                          };
                                        })
                                      }
                                      component={SelectionField}
                                    />
                                  </div>
                                </Col>{" "}
                                <Col lg={6}>
                                  <div className="mb-3">
                                    <Label
                                      className="form-label"
                                      htmlFor="VehicleTypeID"
                                    >
                                      Vehicle Type:
                                    </Label>
                                    <Field
                                      name="VehicleTypeID"
                                      id="VehicleTypeID"
                                      options={
                                        Array.isArray(vehicleTypes) &&
                                        vehicleTypes.map((vehicleType) => {
                                          return {
                                            value: Number(vehicleType.ID),
                                            label: vehicleType.VehicleType,
                                          };
                                        })
                                      }
                                      component={SelectionField}
                                    />
                                  </div>
                                </Col>{" "}
                                <Col lg={6}>
                                  <div className="mb-3">
                                    <Label
                                      className="form-label"
                                      htmlFor="NoOfSeats"
                                    >
                                      Vehicle Capacity:
                                    </Label>
                                    <Field
                                      name="NoOfSeats"
                                      type="number"
                                      className="form-control"
                                      id="NoOfSeats"
                                      placeholder="Enter Vehicle Capacity"
                                      component={TextField}
                                    />
                                  </div>
                                </Col>{" "}
                                <Col lg={6}>
                                  <div className="mb-3">
                                    <Label
                                      className="form-label"
                                      htmlFor="KmPerDay"
                                    >
                                      KM/Day:
                                    </Label>
                                    <Field
                                      name="KmPerDay"
                                      type="number"
                                      className="form-control"
                                      id="KmPerDay"
                                      placeholder="Enter KM Per Day"
                                      component={TextField}
                                    />
                                  </div>
                                </Col>{" "}
                                <Col lg={6}>
                                  <div className="mb-3">
                                    <Label
                                      className="form-label"
                                      htmlFor="RatePerKm"
                                    >
                                      Rate/KM:
                                    </Label>
                                    <Field
                                      name="RatePerKm"
                                      type="number"
                                      className="form-control"
                                      id="RatePerKm"
                                      placeholder="Enter Rate per KM"
                                      component={TextField}
                                    />
                                  </div>
                                </Col>{" "}
                                <Col lg={6}>
                                  <div className="mb-3">
                                    <Label
                                      className="form-label"
                                      htmlFor="DriverAllowancePerDay"
                                    >
                                      Driver Allowance Per Day:
                                    </Label>
                                    <Field
                                      name="DriverAllowancePerDay"
                                      type="number"
                                      className="form-control"
                                      id="DriverAllowancePerDay"
                                      placeholder="Enter Driver Allowance Per Day"
                                      component={TextField}
                                    />
                                  </div>
                                </Col>{" "}
                                <Col lg={6}>
                                  <div className="mb-3">
                                    <Label
                                      className="form-label"
                                      htmlFor="PickUpWithinCity"
                                    >
                                      PickUp Within City:
                                    </Label>
                                    <Field
                                      name="PickUpWithinCity"
                                      type="number"
                                      className="form-control"
                                      id="PickUpWithinCity"
                                      placeholder="Enter PickUp Within City"
                                      component={TextField}
                                    />
                                  </div>
                                </Col>{" "}
                                <Col lg={6}>
                                  <div className="mb-3">
                                    <Label
                                      className="form-label"
                                      htmlFor="DropWithinCity"
                                    >
                                      Drop Within City:
                                    </Label>
                                    <Field
                                      name="DropWithinCity"
                                      type="number"
                                      className="form-control"
                                      id="DropWithinCity"
                                      placeholder="Enter Drop With in City"
                                      component={TextField}
                                    />
                                  </div>
                                </Col>{" "}
                                <Col lg={6}>
                                  <div className="mb-3">
                                    <Label
                                      className="form-label"
                                      htmlFor="EightHrEightyKmWithinCity"
                                    >
                                      Eight Hour Eighty Km Within City:
                                    </Label>
                                    <Field
                                      name="EightHrEightyKmWithinCity"
                                      type="number"
                                      className="form-control"
                                      id="EightHrEightyKmWithinCity"
                                      placeholder="Enter Eight Hour Eighty Km With in City"
                                      component={TextField}
                                    />
                                  </div>
                                </Col>{" "}
                                <Col lg={6}>
                                  <div className="mb-3">
                                    <Label
                                      className="form-label"
                                      htmlFor="IsActive"
                                    >
                                      Status
                                    </Label>
                                    <Field
                                      name="IsActive"
                                      id="IsActive"
                                      options={[
                                        {
                                          label: "Active",
                                          value: true,
                                        },
                                        {
                                          label: "Inactive",
                                          value: false,
                                        },
                                      ]}
                                      component={SelectionField}
                                    />
                                  </div>
                                </Col>
                              </Row>

                              <Row className="mt-2">
                                <Col lg={12}>
                                  <hr></hr>
                                </Col>
                                <Col md="12" className="text-end">
                                  <Button type="submit" className="success">Save</Button>
                                </Col>
                              </Row>
                            </div>
                          </Form>
                        );
                      }}
                    </Formik>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CreateVehicle;
